import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviecbooinginludhiana() {



  const cardData =
  {
    keyword: 'Corporate Cab Booking in Ludhiana',
    heading: 'Aaryan Travels: Corporate Cab Booking in Ludhiana',
    headingDescription: ' Aaryan Travels offers seamless Corporate Cab Booking in Ludhiana for businesses, industrial units, and corporate executives who require reliable and professional transportation. Whether it’s daily staff commuting, client transfers, airport pickups from Chandigarh or Amritsar, or intercity business travel to Delhi, Jalandhar, or Patiala, our fleet of sedans, SUVs, and luxury cars ensures comfort and punctuality. With trained chauffeurs, transparent billing, GPS-enabled vehicles, and flexible rental options, we provide end-to-end corporate mobility solutions across Ludhiana. From Focal Point and Industrial Area-A to Pakhowal Road and Sarabha Nagar, Aaryan Travels is the trusted partner for hassle-free corporate cab booking in Ludhiana.',

    top: 'Top Places to Visit in Ludhiana with Aaryan Travels',

"topPlaces": [
  {
    "title": "Punjab Agricultural University Museum",
    "description": "Located within the campus of Punjab Agricultural University, this open-air rural heritage museum showcases traditional Punjabi village life. It features old farming tools, mud houses, and cultural artifacts. The lush green surroundings and rustic setting offer a peaceful retreat. Folk festivals and fairs are often hosted here. The PAU Museum is Ludhiana’s living tribute to Punjab’s agrarian roots."
  },
  {
    "title": "Nehru Rose Garden",
    "description": "Spread across 30 acres, Nehru Rose Garden is one of the largest rose gardens in Asia, featuring over 1,600 varieties of roses. Pathways, fountains, and open lawns make it ideal for morning walks and picnics. The annual Rose Festival attracts thousands of visitors with cultural events and flower displays. Nehru Rose Garden is Ludhiana’s blooming paradise of beauty and relaxation."
  },
  {
    "title": "Rakh Bagh Park",
    "description": "Rakh Bagh Park is a popular recreational space with a mini toy train, jogging tracks, and children’s play areas. Families and fitness enthusiasts visit regularly for its greenery and peaceful ambiance. The park becomes especially lively during evenings and weekends. The toy train ride is a nostalgic favorite among kids. Rakh Bagh Park is Ludhiana’s favorite outdoor hangout."
  },
  {
    "title": "Gurudwara Nanaksar Jagraon",
    "description": "Gurudwara Nanaksar in Jagraon, near Ludhiana, is a revered Sikh shrine known for its spiritual serenity and grand architecture. The marble pathways and golden domes create a divine atmosphere. Devotees gather during annual fairs and kirtan programs. Langar services here are organized with devotion and care. Gurudwara Nanaksar is Ludhiana’s peaceful sanctuary of faith."
  },
  {
    "title": "Hardy's World Amusement Park",
    "description": "Hardy’s World is one of North India’s largest amusement and water parks, offering thrilling rides, snow zones, and water slides. Adventure seekers enjoy roller coasters while families relax in wave pools. Seasonal events and entertainment shows add extra fun. It is perfect for group outings and school trips. Hardy’s World is Ludhiana’s ultimate destination for excitement and leisure."
  },
  {
    "title": "Phillaur Fort (Maharaja Ranjit Singh Fort)",
    "description": "Phillaur Fort, originally built by the Mughals and later strengthened by Maharaja Ranjit Singh, stands as a historic defense structure. It now serves as a police training academy but allows visitors with permission. The majestic brick walls and arched gateways reflect military heritage. Shooting films and documentaries often feature this location. Phillaur Fort is Ludhiana’s reminder of valiant history."
  },
  {
    "title": "Gurudwara Shri Manji Sahib Alamgir",
    "description": "This Gurudwara is associated with the 10th Sikh Guru, Shri Guru Gobind Singh Ji, who stayed here briefly. The sacred well and historical relics are revered deeply by devotees. The calm surroundings and devotional chants create a serene environment. Religious gatherings and langar services are held daily. Manji Sahib Gurudwara is Ludhiana’s sacred seat of Sikh devotion."
  },
  {
    "title": "Pavilion Mall",
    "description": "Pavilion Mall is Ludhiana’s premier shopping and entertainment hub featuring top fashion brands, multiplex cinema, and food courts. It attracts youngsters and families for weekend outings and movie nights. The stylish interiors and lively ambiance make it a popular social spot. Pavilion Mall is Ludhiana’s go-to destination for modern lifestyle and fun."
  },
  {
    "title": "Clock Tower (Ghanta Ghar)",
    "description": "Built in 1906, the iconic Clock Tower stands at the center of the city, surrounded by bustling bazaars. It serves as a landmark for shoppers exploring Ludhiana’s textile and hosiery markets. The red-brick structure reflects colonial-era architecture. Evening lighting adds charm to its appearance. Ghanta Ghar is Ludhiana’s timeless symbol of commerce and heritage."
  },
  {
    "title": "Tiger Safari, Ludhiana",
    "description": "Ludhiana’s Tiger Safari offers a thrilling wildlife experience with tigers, lions, and other animals housed in natural enclosures. Visitors ride through the safari trail in protected vehicles. The area also includes a mini zoo and bird park. It is educational and exciting for children. Tiger Safari is Ludhiana’s adventurous encounter with the wild."
  }
],


  "services": [
    {
      "name": "Corporate Cab Booking in Ludhiana",
      "description": "Our Corporate Cab Booking service in Ludhiana is designed to provide seamless and reliable transportation solutions for businesses of all sizes. Whether you need regular employee pickups, client transfers, or executive travel, our professional chauffeurs and well-maintained fleet ensure punctuality and comfort. We offer flexible packages, including monthly rentals and one-time bookings, all managed via easy online booking and real-time tracking to simplify corporate travel management."
    },
    {
      "name": "Business Taxi Ludhiana",
      "description": "Business Taxi Ludhiana offers dependable and professional taxi services tailored for business needs. Whether it's airport transfers, meetings, or client visits, our clean and comfortable vehicles arrive on time with courteous drivers. Our service is suitable for short trips and long-term business travel plans, ensuring a hassle-free experience with competitive rates."
    },
    {
      "name": "Book Office Cab Ludhiana",
      "description": "Book Office Cab Ludhiana specializes in daily commute solutions for employees, helping companies manage staff transportation efficiently. Our services include route optimization, shift-wise scheduling, and transparent billing to enhance punctuality and reduce transportation stress. With reliable vehicles and trained drivers, we ensure a smooth office commute experience."
    },
    {
      "name": "Chauffeur Corporate Cab Ludhiana",
      "description": "Experience premium chauffeur-driven corporate cab services in Ludhiana. Our professional drivers are trained to provide courteous, safe, and discreet service for executives and VIP clients. Choose from a range of luxury sedans and SUVs that guarantee comfort and convenience for your important business travels."
    },
    {
      "name": "Staff Transport Ludhiana",
      "description": "Staff Transport Ludhiana offers reliable and secure transportation solutions for your workforce. Ideal for factories, offices, and large organizations, our service includes well-planned routes, timely pickups, and drop-offs to ensure maximum employee satisfaction and operational efficiency. Safety is a top priority, with GPS tracking and verified drivers."
    },
    {
      "name": "Monthly Business Cab Ludhiana",
      "description": "Monthly Business Cab Ludhiana provides cost-effective, long-term corporate cab rental plans that ensure consistent and uninterrupted transportation for your employees or clients. With fixed monthly pricing, priority service, and flexible vehicle options, companies can manage their travel needs easily without worrying about daily bookings."
    },
    {
      "name": "Affordable Corporate Cab Ludhiana",
      "description": "Affordable Corporate Cab Ludhiana offers budget-friendly yet high-quality cab services tailored to the needs of businesses aiming to optimize transportation costs. Our fleet of clean, comfortable vehicles and professional chauffeurs ensures reliable service for all types of corporate travel within and around Ludhiana."
    },
    {
      "name": "Ludhiana Executive Taxi",
      "description": "Ludhiana Executive Taxi delivers premium travel experiences for senior executives and important business guests. Featuring luxury sedans and SUVs with modern amenities, our service emphasizes comfort, professionalism, and punctuality to make every journey productive and pleasant."
    },
    {
      "name": "Reliable Business Cab Ludhiana",
      "description": "Reliable Business Cab Ludhiana guarantees timely, safe, and hassle-free transportation for your corporate requirements. Our fleet is regularly maintained and staffed with professional drivers to ensure that you reach your meetings and events without any delays or issues."
    },
    {
      "name": "Office Travel Cab Ludhiana",
      "description": "Office Travel Cab Ludhiana specializes in transporting office employees efficiently, including daily commutes and corporate events. We offer flexible scheduling, route management, and transparent invoicing, making it easy for businesses to manage employee travel logistics."
    },
    {
      "name": "Employee Shuttle Ludhiana",
      "description": "Our Employee Shuttle service in Ludhiana is designed for organizations requiring group transportation solutions. With a fleet of mini-buses and multi-utility vehicles, we provide scheduled pick-ups and drop-offs to ensure safety, convenience, and on-time arrivals for your teams."
    },
    {
      "name": "Premium Corporate Sedan Ludhiana",
      "description": "Premium Corporate Sedan Ludhiana offers luxurious and comfortable rides for business professionals. Ideal for executive travel, client pickups, and corporate events, our sedans come equipped with modern amenities and are driven by experienced chauffeurs committed to excellence."
    },
    {
      "name": "Corporate Chauffeur Ludhiana",
      "description": "Our Corporate Chauffeur service in Ludhiana delivers professionalism and discretion. With highly trained drivers, this service is perfect for executives and business leaders who demand punctuality, safety, and a pleasant travel experience for all corporate trips."
    },
    {
      "name": "Company Taxi Hire Ludhiana",
      "description": "Company Taxi Hire Ludhiana provides flexible and scalable taxi solutions tailored to the unique transportation demands of businesses. From one-time rides to regular employee transfers, we offer reliable vehicles and easy booking to support your company’s travel needs."
    },
    {
      "name": "Corporate Cab Near Me Ludhiana",
      "description": "Looking for Corporate Cab Near Me in Ludhiana? Our services ensure quick and convenient access to corporate cabs anywhere in the city. With a large fleet and widespread coverage, we guarantee timely pickups and drop-offs to support your business schedules without disruption."
    }
  ],
  "tableData": [
    ["Corporate Cab Booking in Ludhiana", "Business Taxi Ludhiana"],
    ["Book Office Cab Ludhiana", "Chauffeur Corporate Cab Ludhiana"],
    ["Staff Transport Ludhiana", "Monthly Business Cab Ludhiana"],
    ["Affordable Corporate Cab Ludhiana", "Ludhiana Executive Taxi"],
    ["Reliable Business Cab Ludhiana", "Office Travel Cab Ludhiana"],
    ["Employee Shuttle Ludhiana", "Premium Corporate Sedan Ludhiana"],
    ["Corporate Chauffeur Ludhiana", "Company Taxi Hire Ludhiana"],
    ["Corporate Cab Near Me Ludhiana", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Corporate Cab Booking in Ludhiana",
    "WhyChoosedescription": "Aaryan Travels offers seamless and reliable corporate cab booking services tailored for businesses in Ludhiana."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop for Corporate Commutes",
    "WhyChoosedescription": "Ensure punctual and hassle-free transportation for your employees and clients across Ludhiana."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Ludhiana’s Routes",
    "WhyChoosedescription": "Our drivers have extensive knowledge of Ludhiana city to ensure efficient and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Corporate Billing",
    "WhyChoosedescription": "Enjoy upfront pricing and GST-compliant invoices with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, cancellations, and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Business Needs",
    "WhyChoosedescription": "Choose from hourly rentals, daily trips, or monthly contracts based on your organization’s requirements."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, or tempo travellers depending on your team size and comfort preferences."
  }
]

































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab booking services in Ludhiana?',
    answer: 'Yes, Aaryan Travels provides efficient and professional corporate cab booking services across Ludhiana tailored to business travel needs.',
  },
  {
    question: 'How can I book corporate cabs in Ludhiana with Aaryan Travels?',
    answer: 'You can easily book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What vehicle options are available for corporate cab bookings in Ludhiana?',
    answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab bookings suitable for daily employee commute in Ludhiana?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops within Ludhiana.',
  },
  {
    question: 'Are your drivers trained for corporate travel requirements in Ludhiana?',
    answer: 'Absolutely. Our drivers are professional, courteous, and well-trained to meet corporate standards.',
  },
  {
    question: 'Can Aaryan Travels manage group or bulk corporate cab bookings in Ludhiana?',
    answer: 'Yes, we specialize in handling group transportation and bulk cab bookings for corporate meetings and events.',
  },
  {
    question: 'Do you offer monthly billing or invoicing options for corporate clients in Ludhiana?',
    answer: 'Yes, flexible billing options including monthly invoicing are available for our corporate clients.',
  },
  {
    question: 'Is corporate cab booking service available 24x7 in Ludhiana?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab booking services for seamless business travel.',
  },
  {
    question: 'What safety protocols are followed for corporate cab bookings in Ludhiana?',
    answer: 'All vehicles are regularly sanitized and drivers adhere to strict safety and hygiene measures.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Ludhiana?',
    answer: 'Yes, we allow customization of pickup and drop points as per your corporate travel requirements.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Sharma',
    feedback: 'Aaryan Travels’ corporate cab booking service in Ludhiana is highly reliable and professional. Great experience overall.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Verma',
    feedback: 'We have been using Aaryan Travels for our corporate travel in Ludhiana and are very satisfied with their punctuality and service.',
    rating: 5,
  },
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Booking in Ludhiana",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-ludhiana.jpg", // replace with actual image URL
  "description": "Reliable and affordable corporate cab booking services in Ludhiana by Aaryan Travels. Ideal for business travel, employee transport, and office commute with premium sedans and SUVs.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "900",  // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",  // example price, adjust as necessary
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-booking-ludhiana"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Booking in Ludhiana | Business Taxi & Employee Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable corporate cab booking services in Ludhiana by Aaryan Travels. Ideal for business travel, employee transport, and office commute with premium sedans and SUVs."
  />
  <meta
    name="keywords"
    content="Corporate Cab Booking in Ludhiana, Business Taxi Ludhiana, Book Office Cab Ludhiana, Chauffeur Corporate Cab Ludhiana, Staff Transport Ludhiana, Monthly Business Cab Ludhiana, Affordable Corporate Cab Ludhiana, Ludhiana Executive Taxi, Reliable Business Cab Ludhiana, Office Travel Cab Ludhiana, Employee Shuttle Ludhiana, Premium Corporate Sedan Ludhiana, Corporate Chauffeur Ludhiana, Company Taxi Hire Ludhiana, Corporate Cab Near Me Ludhiana"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviecbooinginludhiana;